export default __webpack_public_path__ + "static/media/sb-dropdown.4e0c1fa7.webp";